import script from "./ClientDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientDashboard.vue?vue&type=script&setup=true&lang=js"

import "./ClientDashboard.vue?vue&type=style&index=0&id=d41d96b8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d41d96b8"]])

export default __exports__